module.exports = __webpack_public_path__ + "static/media/Gotham.e19c20e9.otf";